import { render, staticRenderFns } from "./user_system.vue?vue&type=template&id=cb0ba3a8&"
import script from "./user_system.vue?vue&type=script&lang=js&"
export * from "./user_system.vue?vue&type=script&lang=js&"
import style0 from "./user_system.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports